import _isEmpty from 'lodash/isEmpty'
import i18n from '@/i18n/index.js'

const joinArray = arr => {
  if (arr && Array.isArray(arr)) {
    return arr.join(', ')
  } else {
    return '-'
  }
}

export const getMdsUnities = unities => {
  if (unities === 'MDS') return ['MDS']
  if (!Array.isArray(unities)) return []
  return unities.filter(unity => unity === 'MDS')
}

export const getVisibleUnities = unities => {
  return getVisibleValue(getMdsUnities(unities))
}

const translateListString = str => {
  const exists = Boolean(i18n.messages.es.lists[str])
  return exists ? i18n.t("lists['" + str + "']") : str
}

export const translateListValue = val => {
  if (Array.isArray(val)) {
    return val.map(v => translateListString(v))
  } else if (val) {
    return translateListString(val)
  }
  return '-'
}

export const translateList = (list, sort) => {
  if (sort === false) {
    return list.map(i => ({ value: i, text: translateListString(i) }))
  }
  return list
    .map(i => ({ value: i, text: translateListString(i) }))
    .sort((a, b) => a.text.localeCompare(b.text))
}

export const translateLeaders = leaders => {
  return leaders.map(leader => ({
    ...leader,
    professions: translateListValue(leader.professions),
    firstLanguage: translateListValue(leader.firstLanguage),
    secondLanguage: translateListValue(leader.secondLanguage),
    category: translateListValue(leader.category),
    range: translateListValue(leader.range),
    postGrades: translateListValue(leader.postGrades),
    profiles: translateListValue(leader.profiles),
    criteria: translateListValue(leader.criteria),
    specialties: translateListValue(leader.specialties),
    subSpecialties: translateListValue(leader.subSpecialties)
  }))
}

export const getVisibleValue = (val, translated) => {
  if (!val || (val && val.length < 1)) {
    return '-'
  } else {
    if (translated) val = translateListValue(val)
    if (Array.isArray(val)) {
      return joinArray(val)
    } else {
      return val
    }
  }
}

export const getDateFromTimestamp = time => {
  if (time > 0) {
    let date = new Date(time)
    let day = date.getDate()
    day = day > 9 ? day : '0' + day
    let month = date.getMonth() + 1
    month = month > 9 ? month : '0' + month
    let year = date.getFullYear()
    let mins = date.getMinutes()
    mins = mins > 9 ? mins : '0' + mins
    let hours = date.getHours()
    hours = hours > 9 ? hours : '0' + hours

    return day + '-' + month + '-' + year + ' ' + hours + ':' + mins
  } else {
    return '-'
  }
}

export const getDateFromString = str => {
  if (str) {
    let date = new Date(str + ' 00:00')
    let day = date.getDate()
    day = day > 9 ? day : '0' + day
    let month = date.getMonth() + 1
    month = month > 9 ? month : '0' + month
    let year = date.getFullYear()

    return day + '-' + month + '-' + year
  } else {
    return '-'
  }
}

export const getCalendarDate = (time, withHours) => {
  if (time > 0) {
    let strDate = ''
    let date = new Date(time)
    strDate += date.getFullYear()

    let month = date.getMonth() + 1
    month = month > 9 ? month : '0' + month
    strDate += '-' + month

    let day = date.getDate()
    day = day > 9 ? day : '0' + day
    strDate += '-' + day

    if (withHours) {
      let mins = date.getMinutes()
      mins = mins > 9 ? mins : '0' + mins
      let hours = date.getHours()
      hours = hours > 9 ? hours : '0' + hours

      strDate += ' ' + hours + ':' + mins
    }

    return strDate
  }
  return ''
}

export const getCalendarDateFirstDayOfMonth = () => {
  const date = new Date()
  return getCalendarDate(
    new Date(date.getFullYear(), date.getMonth(), 1).getTime()
  )
}

export const getDiffDaysBetweenDates = (date1, date2) => {
  var difference = date1.getTime() - date2.getTime()
  return Math.floor(difference / (1000 * 3600 * 24))
}

export const getPublicationInfo = p => {
  let info = ''
  if (p.authors && p.authors.length) {
    info += p.authors.join(', ')
  }
  if (p.magazine) {
    info += '; ' + p.magazine
  }
  if (p.year) {
    info += ' - ' + p.year
  }
  return info
}

export const isSessionValid = () => {
  let expDate = parseInt(localStorage.getItem('bd-kol-session') || '0')
  return Date.now() < expDate
}

export const getArrayFromObject = (obj, translated, sort) => {
  if (obj) {
    const arr = Object.keys(obj)
    if (translated) return translateList(arr, sort)
    return arr.sort()
  }
  return []
}

export const getArrayFromObjectList = obj => {
  if (obj) {
    const keys = Object.keys(obj).sort()
    const arr = keys.map(k => obj[k])
    return arr
  }
  return []
}

export const getExportableData = (data, isAdmin) => {
  return data.map(item => {
    const i = {
      [i18n.t('fields.name')]: item.name,
      [i18n.t('fields.lastname')]: item.lastname,
      [i18n.t('fields.id')]: item.idNumber,
      [i18n.t('fields.country')]: item.country,
      [i18n.t('fields.city')]: item.city,
      [i18n.t('fields.unity')]: joinArray(getMdsUnities(item.unities)),
      [i18n.t('fields.mobile')]: item.phone,
      [i18n.t('fields.email')]: item.email,
      [i18n.t('fields.profession')]: joinArray(item.professions),
      [i18n.t('fields.postgrade')]: joinArray(item.postGrades),
      [i18n.t('fields.specialty')]: joinArray(item.specialties),
      [i18n.t('fields.subSpecialty')]: joinArray(item.subSpecialties),
      [i18n.t('fields.profile')]: joinArray(item.profiles),
      [i18n.t('fields.criteria')]: joinArray(item.criteria),
      [i18n.t('fields.associations')]: joinArray(item.cientificAs),
      [i18n.t('fields.firstLang')]: item.firstLanguage,
      [i18n.t('fields.secondLang')]: item.secondLanguage,
      [i18n.t('fields.range')]: item.range,
      [i18n.t('fields.observations')]: item.observations
    }
    if (isAdmin)
      i[i18n.t('fields.endContract')] = getDateFromString(item.endContract)
    return i
  })
}

export const getLeadersText = (ids, leadersMap, separator) => {
  if (ids && ids.length && !_isEmpty(leadersMap)) {
    return ids
      .map(id => {
        const l = leadersMap[id]
        return l ? `${l.name} ${l.lastname} (${l.country}, ${l.city})` : ''
      })
      .join(separator ? separator : '<br/>')
  } else {
    return '-'
  }
}
